site.ada.config = site.ada.config || {};

site.ada.config.product = { subtree: true, childList: true };
site.ada.prodWrapper = document.querySelector("section.product-reviews");
site.ada.bzDescString = ". Clicking this will update the content above.";

const productNode = (el)=> {
  if(el.classList?.contains('bv-content-pagination')) {
    return true;
  }
};

const productCallback = ()=> {
  document.dispatchEvent(new CustomEvent('bazaar:pagePanelReplaced'));
};
/**
 * Function that handles all the ADA updates ON LOAD. 
 * When adding a new element to change on Load, add the initializer in the init
 *  and the function to do the changes.
 */
site.ada.productAdaUpdates = function() {
  site.ada.updateNavBtns();
  site.ada.switchQuotes();
  site.ada.updateImages();
  site.ada.outlineStars('.bv_stars_component_container svg path');
  site.ada.outlineReviewStars();
  site.ada.reviewSummaryBtn();
  site.ada.userstatsList();
  site.ada.afterPayProductLoad();
};

/**
 * Function that runs all event listeners that depend on the Bazaar panel.
 * Event called via MutationObserver whenever the reviews pane updates.
 */
site.ada.bazaarPanelUpdates = function() {
  site.ada.updateNavBtns();
  site.ada.switchQuotes();
  site.ada.updateImages();
  site.ada.outlineStars('.bv_stars_component_container svg path');
  site.ada.outlineReviewStars();
  site.ada.reviewSummaryBtn();
  site.ada.userstatsList();
}

site.ada.updateNavBtns = function() {
  site.ada.elementTimer('a.bv-content-btn .bv-off-screen', function(elements) {
    Array.from(elements).forEach(element => {
      if(!element.innerHTML.includes(site.ada.bzDescString)) {
        //Replace next/prev labelling span with more descriptive text
        element.innerHTML = element.innerHTML + site.ada.bzDescString;
      }
    });
  });
}

site.ada.switchQuotes = function() {
  site.ada.elementTimer('div.bv-content-summary-body-text p', function(elements) {
    Array.from(elements).forEach(element => {
      site.ada.switchElement(element, 'q');
    });
  });
}

site.ada.updateImages = function() {
  site.ada.elementTimer('.bv-image-wrapper img', function(elements) {
    Array.from(elements).forEach(element => {
      element.setAttribute('alt', '');
    })
  })
}

site.ada.outlineReviewStars = function() {
  site.ada.elementTimer('.bv-rating-stars-off', function(elements) {
    Array.from(elements).forEach(element => {
      element.style.webkitTextStroke = '1px'; 
      element.style.webkitTextStrokeColor = 'black'; 
    })
  })
}

site.ada.reviewSummaryBtn = function(){
  site.ada.elementTimer('.reviews-accordion-wrapper button.bv_main_container_row_flex', function(elements){
    Array.from(elements).forEach(element =>{
      site.ada.switchElement(element, 'div');
    });
  });
};

site.ada.userstatsList = function(){
  site.ada.elementTimer('ul.bv-author-userstats-list', function(elements){
    Array.from(elements).forEach(element =>{
      element.removeAttribute('role');
      site.ada.switchElement(element, 'div');
    });
  });

  site.ada.elementTimer('li.bv-author-userstats-reviews', function(elements){
    Array.from(elements).forEach(element =>{
      site.ada.switchElement(element, 'div');
    });
  });
};

site.ada.afterPayProductLoad = function() {
  site.ada.elementTimer('afterpay-placement', function(elements){
    Array.from(elements).forEach(element => {
      const afterpayButton = element.shadowRoot.getElementById('logo-link');
      if (afterpayButton) {
        afterpayButton.setAttribute('aria-hidden', true);
        afterpayButton.setAttribute('tabindex', -1);
      };
    });
  });
}

// Event listeners go here.
document.addEventListener('bazaar:pagePanelReplaced', site.ada.bazaarPanelUpdates);
document.addEventListener('DOMContentLoaded', site.ada.productAdaUpdates);
/*
 * MutationObserver that detects when the BazaarVoice pagination panel replaced.
 * This happens when the prev/next buttons are pressed and more reviews are loaded.
 */

if (site.ada.observer){site.ada.observer(productNode, productCallback, site.ada.prodWrapper, site.ada.config.product);}